import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_dropdown = _resolveComponent("input-dropdown")!

  return (_openBlock(), _createBlock(_component_input_dropdown, {
    id: _ctx.id,
    modelValue: _ctx.modelValue,
    "data-items": _ctx.allCountries,
    "value-field": "countryCode",
    "text-field": "name",
    placeholder: _ctx.localize('chooseCountry'),
    filterable: true,
    required: true,
    width: _ctx.width,
    "onUpdate:modelValue": _ctx.onChange
  }, null, 8, ["id", "modelValue", "data-items", "placeholder", "width", "onUpdate:modelValue"]))
}